/**
 * SCHÉMAS DE VALIDATION - PRODUITS
 * Validation Zod pour les formulaires de création/édition de produits
 */

import { z } from 'zod';

/**
 * Schéma pour la création d'un produit
 */
export const createProductSchema = z
  .object({
    name: z
      .string()
      .min(1, 'Le nom du produit est requis')
      .min(3, 'Le nom doit contenir au moins 3 caractères')
      .max(100, 'Le nom ne peut pas dépasser 100 caractères'),

    start_date: z
      .string()
      .min(1, 'La date de début est requise')
      .refine((date) => !isNaN(Date.parse(date)), {
        message: 'Date de début invalide',
      }),

    end_date: z
      .string()
      .min(1, 'La date de fin est requise')
      .refine((date) => !isNaN(Date.parse(date)), {
        message: 'Date de fin invalide',
      }),
  })
  .refine(
    (data) => {
      const start = new Date(data.start_date);
      const end = new Date(data.end_date);
      return end >= start;
    },
    {
      message: 'La date de fin doit être postérieure ou égale à la date de début',
      path: ['end_date'],
    }
  );

/**
 * Type inféré du schéma
 */
export type CreateProductInput = z.infer<typeof createProductSchema>;
